import type { Finding, FindingSeverity } from "./Finding";
import { SEVERITY_RANK } from "./SEVERITY_RANK";

// Худший `severity` среди находок; находок нет — `null` (ошибок в категории не нашлось).
export const worstSeverity = (findings: readonly Finding[]): FindingSeverity | null =>
  findings.reduce<FindingSeverity | null>(
    (worst, { severity }) =>
      worst === null || SEVERITY_RANK[severity] > SEVERITY_RANK[worst] ? severity : worst,
    null,
  );
